import { AD_FLAGS } from '../adsterra/adsterraConfig';

/**
 * Tracks the number of legitimately completed songs.
 * Only songs that played to their natural end should be counted —
 * manual skips, errors, and page reloads must NOT call recordCompletedSong().
 */
export class SongProgressTracker {
  constructor(threshold = AD_FLAGS.adBreakThreshold) {
    this._count = 0;
    this._threshold = threshold;
  }

  recordCompletedSong() {
    this._count += 1;
    return this._count;
  }

  isThresholdReached() {
    return this._count >= this._threshold;
  }

  reset() {
    this._count = 0;
  }

  getCount() {
    return this._count;
  }
}
